import React from 'react';

import 'antd/dist/antd.css';
import './pages/ListContratos/global.css';
import './pages/ListContratos/addContratoinUser.css';
import './pages/ListUsuarios/style.css';
import './pages/ListUsuarios/addUser.css';
import './pages/ListUsuarios/addUser/notificacao.css';
import './pages/ListUsuarios/addUser/permissaoInPainel.css';
import './pages/ListUsuarios/addUser/permissaoInApp.css';
import './pages/ListProcessosJuridicos/style.css';
import './pages/ListAssociacoes/style.css';
import './pages/LayoutDashBoard/style.css';
import './pages/Dashboard/style.css';
import './pages/ListMessages/style.css';
import './pages/PageMessage/style.css';
import './pages/ListAtendimentos/style.css';
import './pages/ListAtendimentos/styleCalendar.css';
import './pages/Relatorios/Acesso/UltimoAcesso/style.css';
import './pages/ListContratos/Entidades/votacao.css';
import './pages/Acessos/style.css';

const Theme = () => (<React.Fragment></React.Fragment>);

export default Theme;
